'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformExistentialExpression = transformExistentialExpression;
exports.replaceWithSafeCall = replaceWithSafeCall;
exports.transformSafeMemberExpression = transformSafeMemberExpression;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _placeAtNode = require('ast-loc-utils/lib/placeAtNode');

var _placeAtNode2 = _interopRequireDefault(_placeAtNode);

var _ref = require('./ref');

var _is = require('./is');

var _is2 = _interopRequireDefault(_is);

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformExistentialExpression(path) {
  return path.replaceWith((0, _placeAtNode2.default)(_types2.default.binaryExpression("!=", path.node.argument, (0, _placeAtNode2.default)(_types2.default.nullLiteral(), path.node)), path.node));
}function replaceWithSafeCall(path, callExpr) {
  var callee = void 0,
      typeofExpr = void 0;

  if ((0, _is2.default)("MemberExpression", callExpr.callee)) {
    var memberExpr = callExpr.callee;

    var _hoistRef = (0, _ref.hoistRef)(path, memberExpr.object, "obj"),
        objectRef = _hoistRef.ref,
        object = _hoistRef.assign;

    var property = memberExpr.property,
        propertyRef = memberExpr.property;
    if (memberExpr.computed) {
      var _hoistRef2 = (0, _ref.hoistRef)(path, memberExpr.property, "prop");

      propertyRef = _hoistRef2.ref;
      property = _hoistRef2.assign;
    }

    typeofExpr = _types2.default.memberExpression(object, property, memberExpr.computed);
    callee = _types2.default.memberExpression(objectRef, propertyRef, memberExpr.computed);
  } else {
    var _hoistRef3 = (0, _ref.hoistRef)(path, callExpr.callee);

    callee = _hoistRef3.ref;
    typeofExpr = _hoistRef3.assign;
  }

  // Generate actual safecall expr
  // f?(x) -> (typeof f === "function") ? f(x) : null
  return path.replaceWith((0, _astLocUtils.placeTreeAtLocWhenUnplaced)(_types2.default.conditionalExpression(_types2.default.binaryExpression("===", _types2.default.unaryExpression("typeof", typeofExpr), _types2.default.stringLiteral("function")), _types2.default.callExpression(callee, callExpr.arguments), _types2.default.nullLiteral()), (0, _astLocUtils.getLoc)(path.node)));
}function transformSafeMemberExpression(path) {
  // x?.y -> x == null ? x : x.y
  // x?[y] -> x == null ? x : x[y]
  var node = path.node;
  var object = node.object;

  // Demote to an ordinary member expression

  node.type = "MemberExpression";

  // Generate null check, hoisting ref if necessary.
  var left = object.type === "Identifier" || object.type === "SafeMemberExpression" || object.type === "ThisExpression" ? object : function () {
    var ref = (0, _placeAtNode2.default)(path.scope.generateDeclaredUidIdentifier("ref"), object);
    node.object = ref;
    return (0, _placeAtNode2.default)(_types2.default.assignmentExpression("=", ref, object), object);
  }();

  var nullCheck = (0, _placeAtNode2.default)(_types2.default.binaryExpression("==", left, (0, _placeAtNode2.default)(_types2.default.nullLiteral(), object)), object);

  // Gather trailing subscripts/calls, which are parent nodes:
  // eg; in `o?.x.y()`, group trailing `.x.y()` into the ternary
  var tail = path;
  while (tail.parentPath) {
    var parent = tail.parentPath;
    var hasChainedParent = parent.isMemberExpression() || parent.isCallExpression() && parent.get("callee") === tail || parent.node.type === "TildeCallExpression" && parent.get("left") === tail;

    if (hasChainedParent) {
      tail = tail.parentPath;
    } else {
      break;
    }
  }var ternary = (0, _placeAtNode2.default)(_types2.default.conditionalExpression(nullCheck, (0, _placeAtNode2.default)(_types2.default.nullLiteral(), tail.node), tail.node), tail.node);

  return tail.replaceWith(ternary);
}